import { Box, Stack, useTheme } from '@mui/material';
import Paper from '@/components/Paper';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import Image from 'next/image';
import Arrow from '../../../public/assets/posts/Arrow.svg';

type PostProps = {
  image: string;
  title: string;
  description: string;
  link: string;
};

const Post = ({ image, title, description, link }: PostProps) => {
  const { matches } = useResponsive();
  const theme = useTheme();
  return (
    <Paper elevation={14} sx={{ padding: matches({ xs: 4, lg: 8 }) }}>
      <Stack>
        <Box position="relative" height="229px" mb={{ xs: 3, lg: 6 }}>
          <Image
            fill
            src={image}
            alt={title}
            style={{ objectFit: 'cover', borderRadius: 24 }}
          />
        </Box>
        <Typography
          variant={matches({ xs: 'body2', lg: 'subtitle' })}
          weight="bold"
          mb={{ xs: 1.5, lg: 2 }}
        >
          {title}
        </Typography>
        <Typography
          color="textColor.A60"
          variant={matches({ xs: 'body3', lg: 'body2' })}
          mb={{ xs: 3, lg: 8.75 }}
        >
          {description}
        </Typography>
        <a
          href={link}
          target="_blank"
          style={{
            alignSelf: 'start',
            textDecoration: 'none',
            color: theme.palette.textColor.A80,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            marginBottom: 0
          }}
        >
          <Typography
            variant="body2"
            weight={matches({ xs: 'normal', lg: 'bold' })}
          >
            ادامه مطلب
          </Typography>
          <Image src={Arrow} width={12} height={12} alt="" />
        </a>
      </Stack>
    </Paper>
  );
};

export default Post;
